import React, { useEffect, useState } from 'react';
import { API, axios } from '../../utils/api';

// Le persone dello staff (backend/staff.py): nome, iniziale, colore (M oro, K viola, collaboratori blu).
// Lette una volta sola e condivise da barra, agenda, Oggi e liste.

let cache = null;
let inCorso = null;
const ascoltatori = new Set();

const carica = () => {
  if (!inCorso) {
    inCorso = axios.get(`${API}/staff/persone`).then((r) => {
      cache = r.data;
      ascoltatori.forEach((f) => f(cache));
      return cache;
    }).catch(() => { inCorso = null; return null; });
  }
  return inCorso;
};

export const dimenticaPersone = () => { cache = null; inCorso = null; };

export const usePersone = () => {
  const [dati, setDati] = useState(cache);
  useEffect(() => {
    ascoltatori.add(setDati);
    if (!cache) carica();
    return () => ascoltatori.delete(setDati);
  }, []);
  const persone = dati?.persone || [];
  const perId = Object.fromEntries(persone.map((p) => [p.id, p]));
  return { persone, perId, ioId: dati?.io, io: perId[dati?.io] || null };
};

export const Iniziale = ({ persona, taglia = 20, className = '' }) => {
  if (!persona) return null;
  return (
    <i className={`a col-${persona.colore || 'blu'} ${className}`} style={{ width: taglia, height: taglia, fontSize: taglia * 0.36, fontStyle: 'normal' }}
      title={persona.nome} aria-hidden="true">{persona.iniziale || (persona.nome || '?').charAt(0)}</i>
  );
};

export const ChiFa = ({ persona }) => (persona ? <span className="who"><Iniziale persona={persona} />{persona.nome}</span> : null);
